/*
 * Copyright (c) 2025 Frayo and HomeChef360. All Rights Reserved.
 *
 * CONFIDENTIAL & PROPRIETARY
 * This software and its source code are the confidential and proprietary
 * information of Frayo and HomeChef360. Unauthorized copying, modification,
 * distribution, disclosure, or use of this code, in whole or in part, via any
 * medium, is strictly prohibited without prior written consent.
 *
 * Violations will be subject to legal action in the State of Florida and may
 * also be pursued under applicable U.S. federal law.
 */

import React from "react";
import axios from "axios";
import { getToken } from "../../../auth";

//BASE_URL
const API_URL = process.env.REACT_APP_API_URL;

const getPlans = async (chefId: any) => {
  const response = await axios
    .post(`${API_URL}get-plan`, { chefId });
    return response.data;
};

const getCoupons = async (id : number) => {
  const response = await axios
    .get(`${API_URL}get-coupons/${id}`);
    return response.data;
};

const unsubscribePlan = async (data: any) => {
        const response = await axios.post(`${API_URL}unsubscribe-plan`, data);
  return response.data;
};
const createCheckoutSession = async (data: any) => {
       
  const response = await axios.post(
    `${API_URL}create-checkout-session`,
    data
  );
    
  return response.data;
};

const handleWebhook = async (data: any) => {
        const response = await axios.post(
    `${API_URL}plan-webhook`,
    data
  );
  return response.data;
};
const getPaymentStatus = async (session_id: string, subscribedActivePlanId: any) => {
  
  const response = await axios.post(`${API_URL}payment-status`, {
    session_id,
    subscribedActivePlanId
  });

    return response.data;
};

const updatePlanRenewal = async (updatedData: any) => {
        const res = await axios.put(`${API_URL}plan-autorenewal`, updatedData, getToken());
  return res.data;
};
const getPlanForAffiliate = async () => {
  const response = await axios
    .post(`${API_URL}get-plan-affiliate`,);
    return response.data;
};


const createPromoteKitCheckoutSession = async (data: any) => {
        const response = await axios.post( `${API_URL}create-promotekit-session`,  data);
  return response.data;
};

export {
  getPlans,
  getCoupons,
  unsubscribePlan,
  createCheckoutSession,
  handleWebhook,
  getPaymentStatus,
  updatePlanRenewal,
  getPlanForAffiliate,
  createPromoteKitCheckoutSession,

};
